// frontend/src/utils/activeRole.js

/**
 * Per-tab "active role" for dual-capability accounts.
 *
 * A user can hold both a billing tier (user_type ∈ {trial, professional,
 * enterprise}) AND the recommender capability (is_recommender). They pick a
 * role from /choose-role on first entry; subsequent navigations within the
 * tab read this value to skip the picker. The Navbar's "Switch view" menu
 * updates it, then navigates.
 *
 * Per-TAB (not per-account) on purpose: a user may want to keep two tabs
 * open, one in each role. sessionStorage is per-tab, localStorage is shared,
 * so sessionStorage matches the intent.
 */

const ROLE_STORAGE_KEY = "leadifyai.activeRole";

export const setActiveRole = (role) => {
  try {
    if (role === "business" || role === "recommender") {
      sessionStorage.setItem(ROLE_STORAGE_KEY, role);
    } else {
      sessionStorage.removeItem(ROLE_STORAGE_KEY);
    }
  } catch {
    // sessionStorage may be unavailable (private mode); fail silently.
  }
};

export const getActiveRole = () => {
  try {
    return sessionStorage.getItem(ROLE_STORAGE_KEY) || null;
  } catch {
    return null;
  }
};
